import ClientDashboardLayout from "../../../../components/clientDashboard/ClientDashboardLayout";
import BankConnections from "./sections/bankConnections";

export default function CustomerSettings() {
  return (
    <ClientDashboardLayout contentAlign="center" contentMaxWidth="100%">
      <BankConnections />
    </ClientDashboardLayout>
  );
}
